import { commonService } from "../../../utils/commonService";
import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import { Col, Form, Table } from "react-bootstrap";
import Loader from "../../Loader/Loader";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

const CustomerType = () => {
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const crmPropertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.crmPropertyDetail
    );

    const [marketSegmentData, setMarketSegmentData] = useState(null);
    const [customerType, setCustomerType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const customerTypeRef = useRef([]);

    const getMarketSegmentData = async () => {
        setLoading(true);
        let marketSegmentResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
                body: {
                    categorynamebycomma: "Market Segment", propertyid: parseInt(window.location.href.includes("/crm")
                        ? crmPropertyDetailFromRTK?.propertyid
                        : propertyDetailFromRTK?.propertyid)
                },
            },
            false
        );

        let response = apiResponse(false, marketSegmentResponse);

        if (response?.isValidate) {
            setMarketSegmentData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setMarketSegmentData(null);
            setLoading(false);
        }
    };

    const getCustomerType = async () => {
        customerTypeRef.current = [];
        setLoading(true);
        let customerTypeResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.RATEIQ_CUSTOMER_TYPE.GET_LIST,
                body: {
                    propertyid: window.location.href.includes("/crm")
                        ? crmPropertyDetailFromRTK?.propertyid
                        : propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, customerTypeResponse);

        if (response?.isValidate) {
            response?.data?.data?.map((item) => {
                customerTypeRef.current = [
                    ...customerTypeRef.current,
                    {
                        rateiqcustomertypeid: 0,
                        customertype: item?.customertype,
                        ratevalue: item?.ratevalue,
                        propertyid: item?.propertyid,
                    },
                ];
            });
            setCustomerType(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setCustomerType(null);
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setSubmitLoading(true);

        let saveResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.RATEIQ_CUSTOMER_TYPE.SAVE,
                body: {
                    F: customerTypeRef.current,
                },
            },
            true
        );

        let response = apiResponse(true, saveResponse, setSubmitLoading);

        if (response?.isValidate) {
        }

        if (!response?.isValidate) {
        }
    };

    useEffect(() => {
        getMarketSegmentData();
        getCustomerType();
    }, []);
    return (
        <div>
            <Col xl={12}>
                <div className="table__container">
                    <div className="stripped__table">
                        <div className="table-responsive maxHeight400">
                            <Table>
                                <thead className="tbl-header-sticky my-tbl-header-sticky">
                                    <tr>
                                        <th>Customer Type</th>
                                        <th className="text-center width100">%In Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td>
                                                <Skeleton count={5} />
                                            </td>
                                            <td>
                                                <Skeleton count={5} />
                                            </td>
                                        </tr>
                                    ) : (
                                        marketSegmentData?.map((item, index) => {
                                            let findMarketSegment = customerType?.filter(
                                                (x) => x?.customertype === item?.term
                                            );

                                            return (
                                                <tr className="shadowOnHover">
                                                    <td>{item?.term}</td>
                                                    <td className="p-1">
                                                        <Form.Control id={commonService.generateGlobalClickTrackerID("CustomerType", "in-rate", item?.term)}
                                                            type="text"
                                                            className="py-0 px-2"
                                                            maxLength={6}
                                                            defaultValue={findMarketSegment?.[0]?.ratevalue}
                                                            onChange={(e) => {
                                                                const findIndexOfCustomerType =
                                                                    customerTypeRef.current?.findIndex(
                                                                        (x) => x?.customertype === item?.term
                                                                    );

                                                                if (findIndexOfCustomerType >= 0) {
                                                                    customerTypeRef.current[
                                                                        findIndexOfCustomerType
                                                                    ].ratevalue = e.target.value;
                                                                } else {
                                                                    customerTypeRef.current = [
                                                                        ...customerTypeRef.current,
                                                                        {
                                                                            rateiqcustomertypeid: 0,
                                                                            customertype: item?.term,
                                                                            ratevalue: e.target.value,
                                                                            propertyid: window.location.href.includes(
                                                                                "/crm"
                                                                            )
                                                                                ? crmPropertyDetailFromRTK?.propertyid
                                                                                : propertyDetailFromRTK?.propertyid,
                                                                        },
                                                                    ];
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </Col>

            <div className="rate-iq-setting-modal footer-buttons pt-2">
                {submitLoading ? (
                    <button className="default-btn primary-btn" type="button" disabled>
                        <span
                            className="spinner-border spinner-border-sm me-3"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Loading...
                    </button>
                ) : (
                    <button id={commonService.generateGlobalClickTrackerID("CustomerType", "submit", "")}
                        className="default-btn primary-btn"
                        onClick={() => {
                            handleSubmit();
                        }}
                    >
                        Submit
                    </button>
                )}
            </div>
        </div>
    );
};

export default CustomerType;
